import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { Box, Typography, TextField, Grid, Button, IconButton, FormControlLabel, Checkbox, CircularProgress, useMediaQuery, Skeleton } from '@mui/material';
import { FaEye, FaEyeSlash, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaFacebook } from 'react-icons/fa';
import "react-toastify/dist/ReactToastify.css";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import Organizationsimage from "../../../assets/organizationsSignup.webp";
import Headrepage from "../../mainpage/Headerpages/OrganizationsHeaderpage";
import Footer from "../../mainpage/FooterOrganizations";
import {OrganizationsSignup} from "../../../helper/base_url";
import useNetworkStatus from "../../../helper/NetworkStatus";

function Signup(){
  const [loading, setLoading] = useState(false);
  const [checkingToken, setCheckingToken] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({ name: "", username: "", password: "", confirmPassword: "", company: "", role: "company" });
   const [errors, setErrors] = useState({});
  const isMobile = useMediaQuery('(max-inline-size:600px)');
  const isTablet = useMediaQuery('(min-inline-size:601px) and (max-inline-size:960px)');
  const { isOnline } = useNetworkStatus();
  const navigate = useNavigate();

  // Delay + shimmer while checking token
  useEffect(() => {
  const token = localStorage.getItem('company_token');
  if (token) {
    setTimeout(() => {
      navigate("/organizations/dashboard/pending-project");
    }, 1000); // 1-second delay
  } else {
    setCheckingToken(false);
  }
  }, [navigate]);

  // Email and Password validation
  const validateEmail = (email) => {
    const emailRegex = /^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i;
    return emailRegex.test(email);
  };


  // Handle field changes + real-time validation
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));

    if (name === "username") {
      if (!validateEmail(value)) {
        setErrors((prev) => ({ ...prev, username: "Invalid email format" }));
      } else {
        setErrors((prev) => ({ ...prev, username: "" }));
      }
      // Also re-check confirmPassword match when password changes
      if (data.confirmPassword && value !== data.confirmPassword) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "Passwords do not match",
        }));
      } else {
        setErrors((prev) => ({ ...prev, confirmPassword: "" }));
      }
    }

    if (name === "confirmPassword") {
      if (value !== data.password) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "Passwords do not match",
        }));
      } else {
        setErrors((prev) => ({ ...prev, confirmPassword: "" }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!data.name.trim() || !data.username.trim() || !data.password.trim() || !data.confirmPassword.trim()) {
      toast.error("All fields are required");
      return;
    }

    if (!validateEmail(data.username)) {
      setErrors((prev) => ({ ...prev, username: "Invalid email format" }));
      toast.error("Invalid email format");
      return;
    }

    const regExspecialChars = /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[a-z])(?!.*\s).{8,}$/;

    if (data.password.length < 8) {
      toast.error("Password should be more than 8 characters");
      return;
    }

    if (!regExspecialChars.test(data.password)) {
      toast.error("Password must contain 1 digit, 1 special character, 1 lowercase & 1 uppercase letter");
      return;
    }

    if (data.password !== data.confirmPassword) {
      setErrors((prev) => ({ ...prev, confirmPassword: "Passwords do not match" }));
      toast.error("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${OrganizationsSignup}`, data, {
        headers: { "Content-Type": "application/json" },
      });

      const { message, error } = response.data;

      if (error) {
        toast.error(message || "Account already exists");
      } else {
        toast.success(message || "Registration successful!");
        setTimeout(() => navigate("/organizations/signin"), 1000);
      }

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Network error, please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };


  // Show shimmer while checking token
    if (checkingToken) {
    return (
        <Box
          sx={{
            height : "100vh",
            width : "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#f5f7fa",
            padding: "20px",
          }}
        >
          <Box
            sx={{
              width : { xs: "90%", sm: "70%", md: "50%", lg: "40%" },
              padding: 3,
              borderRadius: 3,
              boxShadow: 3,
              bgcolor: "#ffffff",
            }}
          >
            <Skeleton variant="text" height={50} width="80%" sx={{ mb: 3 }} />
            <Skeleton variant="rectangular" height={56} sx={{ mb: 2 }} />
            <Skeleton variant="rectangular" height={56} sx={{ mb: 2 }} />
            <Skeleton variant="rectangular" height={56} sx={{ mb: 3 }} />
            <Skeleton variant="rounded" height={40} width="100%" sx={{ mb: 3 }} />
            <Skeleton variant="text" width="60%" />
          </Box>
        </Box>
    );
  }
  
  return (
    <div className="students-flex">
      <Headrepage />
      {isOnline ? (
      <div className="homepagecolores">
      <div style={{ width : "100%", overflowX: "hidden", overflowY: "auto", height : "91vh" }}>
      <ToastContainer position="top-center" />
      <Grid container justifyContent="center" alignItems="center" style={{ padding: "40px 20px" }}>
        <Grid item xs={12} sm={8} md={6} lg={4}>
            <Typography variant="h5" align="center" gutterBottom sx={{color:"#043885"}}>
              Sign Up for a Company Account
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField label="Name" name="name" fullWidth margin="normal" value={data.name} onChange={handleOnChange} required disabled={loading} />
              <TextField label="Company Name" name="company" fullWidth margin="normal" value={data.company} onChange={handleOnChange} required disabled={loading} />
              <TextField label="Email" type="email" name="username" fullWidth margin="normal" value={data.username} onChange={handleOnChange} required disabled={loading} error={!!errors.username}  helperText={errors.username}/>
              <Box position="relative">
                <TextField label="Password" type={showPassword ? "text" : "password"} name="password" fullWidth margin="normal" value={data.password} onChange={handleOnChange} required disabled={loading}  error={!!errors.password} helperText={errors.password} autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </IconButton>
                  ),
                }}
              />
              </Box>
              <TextField label="Confirm Password" type="password" name="confirmPassword" fullWidth margin="normal" value={data.confirmPassword} onChange={handleOnChange} required disabled={loading}  error={!!errors.confirmPassword} helperText={errors.confirmPassword}/>
              <FormControlLabel control={<Checkbox required />} label="I agree with the User terms and privacy policy" />
              <Button type="submit" variant="contained" color="primary" fullWidth style={{ marginTop : 10 }} disabled={loading}>
                {loading ? <CircularProgress size={24} /> : 'Sign Up'}
              </Button>
            </form>
            <Typography align="center" style={{ marginTop : 15, marginBottom :"10px" }}>
              Already have an account? <Link to="/organizations/signin">Login here</Link>
            </Typography>
          {/* </Paper> */}
        </Grid>
         {!isMobile && !isTablet && (
            <Grid item xs={12} sm={8} md={6} lg={4} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <img src={Organizationsimage} alt="Signup Illustration" style={{ width : "100%", maxWidth : "500px", height : "100%", padding: "20px", borderRadius:"10px" }} />
            </Grid>
          )}
        </Grid>
        </div>
           <div className="homepage-footers-images">
            <Footer />
          <footer className="homepage-footers">
          <hr className='homepage-footer-hr'/>
          <div className="learners-footers-seokeywords">
          </div>
            <div className="footer-social">
            <div className="homepage-footer-copyright">
              <p>© Huebits[2025].All Rights Reserved.</p>
            </div>
            <div className='footer-social-icons'>
              <Link to="https://www.linkedin.com/company/huebits/mycompany" target="_blank" rel="noopener noreferrer"><FaLinkedin  className="social-icon"/></Link>
              <Link to="https://x.com/HuebitsTech" target="_blank" rel="noopener noreferrer"><FaTwitter className="social-icon" /></Link>
              <Link to="https://www.instagram.com/huebits_tech/" target="_blank" rel="noopener noreferrer"><FaInstagram className="social-icon" /></Link>
              <Link to="https://www.youtube.com/@HuebitsTech" target="_blank" rel="noopener noreferrer"><FaYoutube className="social-icon" /></Link>
              <Link to="https://www.facebook.com/profile.php?id=61571753805069" target="_blank" rel="noopener noreferrer"><FaFacebook className="social-icon" /></Link>
          </div>
          </div>
          </footer>
          </div>
        </div>
        ) : (
            <div>
                <ShimmerSimpleGallery card imageHeight={180} row={3} col={3} gap={20} />
            </div>
        )}
      </div>
   );
};

export default Signup;
